import { Controller } from 'react-hook-form';

import RadioGroup from './RadioGroup';
import { type ControlledRadioGroupProps } from './types';

const ControlledRadioGroup = (props: ControlledRadioGroupProps) => {
    const { name, control, defaultValue, children } = props;
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState }) => (
                <RadioGroup {...props} value={field.value} errorMessage={fieldState.error?.message} onChange={(e) => field.onChange(e.target.value)}>
                    {children}
                </RadioGroup>
            )}
        />
    );
};

export default ControlledRadioGroup;
